<style lang="scss">
/* ===== Layout ===== */
.page-inner {
    max-width: 1200px;
    margin: 0 auto;
}

/* ===== Table Card ===== */
.table-card {
    border-radius: 8px;

    :deep(.ant-card-head) {
        border-bottom: 1px solid #f0f0f0;
        padding: 0 16px;
        min-height: 48px;
    }

    :deep(.ant-card-body) {
        padding: 0 16px 16px;
    }
}

.card-title-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.card-title-text {
    font-weight: 600;
    font-size: 14px;
}

/* ===== Toolbar ===== */
.table-toolbar {
    padding: 12px 16px;
    background: #fafafa;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    gap: 8px;
    align-items: center;
}

/* ===== PC vs Mobile Toggle ===== */
.user-card-list {
    display: none;
    gap: 12px;

    .user-mobile-card {
        border-radius: 10px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

        :deep(.ant-card-body) {
            padding: 12px 14px;
        }
    }

    .mobile-card-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        padding-bottom: 8px;
        border-bottom: 1px solid #f0f0f0;
    }

    .mobile-card-title {
        display: flex;
        align-items: center;
        font-weight: 600;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.88);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .mobile-card-body {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 10px;
    }

    .mobile-field {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
    }

    .mobile-label {
        color: rgba(0, 0, 0, 0.45);
        min-width: 64px;
        flex-shrink: 0;
        font-size: 12px;
    }

    .mobile-value {
        color: rgba(0, 0, 0, 0.88);
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .mobile-card-foot {
        display: flex;
        gap: 8px;
        padding-top: 8px;
        border-top: 1px solid #f5f5f5;
    }
}

/* ===== Pagination ===== */
.table-pagination {
    display: flex;
    justify-content: flex-end;
    padding-top: 12px;
}

/* ===== Balance Clickable ===== */
.balance-link {
    color: #1677ff;
    cursor: pointer;
    font-weight: 500;

    &:hover {
        text-decoration: underline;
    }
}

/* ===== Mobile Responsive ===== */
@media screen and (max-width: 768px) {

    .user-table-pc,
    .table-pagination {
        display: none !important;
    }

    .user-card-list {
        display: flex !important;
        flex-direction: column;
    }

    .table-card :deep(.ant-card-head) {
        padding: 0 12px;
        min-height: 44px;
    }

    .table-card :deep(.ant-card-body) {
        padding: 0 12px 12px;
    }

    .table-toolbar {
        padding: 10px 12px;
    }
}

@media screen and (max-width: 480px) {
    .mobile-label {
        min-width: 56px;
        font-size: 11px;
    }

    .mobile-value {
        font-size: 12px;
    }
}
</style>

<template>
    <a-layout style="min-height: 100vh;">
        <UserHead />
        <a-layout>
            <a-layout-header style="padding: 0; background: #fff; border-bottom: 1px solid #f0f0f0;">
                <HeadTop />
            </a-layout-header>
            <a-layout-content class="page-content" style="padding: 24px; background: #f5f7fa;">
                <div class="page-inner">
                    <a-card :bordered="false" class="table-card">
                        <template #title>
                            <div class="card-title-row">
                                <span class="card-title-text">用户管理</span>
                                <a-tag color="blue">{{ userList.total }} 条</a-tag>
                            </div>
                        </template>

                        <div class="table-toolbar">
                            <a-input v-model:value="userList.keyword" placeholder="邮箱/昵称/uid关键词" style="width: 200px;"
                                allow-clear @press-enter="getUserList" />
                            <a-button type="primary" @click="getUserList">搜索</a-button>
                        </div>

                        <a-table class="user-table-pc" :data-source="userList.data" :pagination="false" row-key="uid"
                            :scroll="{ x: 700 }" size="small" bordered :loading="tableLoading" :columns="tableColumns">
                            <template #bodyCell="{ column, record }">
                                <template v-if="column.key === 'money'">
                                    <span class="balance-link" @click="editMoneyDialog(record)">{{ record.money
                                        }}</span>
                                </template>
                                <template v-else-if="column.key === 'action'">
                                    <a-space size="small">
                                        <a-button type="primary" size="small" @click="editDialog(record)">编辑</a-button>
                                    </a-space>
                                </template>
                            </template>
                        </a-table>

                        <!-- 手机端卡片列表 -->
                        <div class="user-card-list" v-if="userList.data && userList.data.length > 0">
                            <a-card v-for="record in userList.data" :key="record.uid" class="user-mobile-card"
                                :bordered="false">
                                <div class="mobile-card-head">
                                    <div class="mobile-card-title">
                                        UID: {{ record.uid }}
                                    </div>
                                    <a-tag color="blue" size="small">{{ record.username || record.user_email }}</a-tag>
                                </div>
                                <div class="mobile-card-body">
                                    <div class="mobile-field">
                                        <span class="mobile-label">邮箱</span>
                                        <span class="mobile-value">{{ record.user_email || '-' }}</span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">昵称</span>
                                        <span class="mobile-value">{{ record.username || '-' }}</span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">上级</span>
                                        <span class="mobile-value">{{ record.higher_uid || '-' }}</span>
                                    </div>
                                    <div class="mobile-field">
                                        <span class="mobile-label">余额</span>
                                        <span class="mobile-value balance-link" @click="editMoneyDialog(record)">{{
                                            record.money }}</span>
                                    </div>
                                </div>
                                <div class="mobile-card-foot">
                                    <a-button type="primary" size="small" @click="editDialog(record)">编辑</a-button>
                                    <a-button size="small" @click="editMoneyDialog(record)">充值/扣款</a-button>
                                </div>
                            </a-card>
                        </div>

                        <!-- 分页 -->
                        <div class="table-pagination">
                            <a-pagination v-model:current="userList.currentPage" v-model:page-size="userList.pageSize"
                                :page-size-options="[10, 25, 50]" show-size-changer show-quick-jumper
                                :show-total="(total) => `共 ${total} 条`" :total="userList.total"
                                @change="onPageChange" />
                        </div>
                    </a-card>
                </div>
            </a-layout-content>
        </a-layout>
    </a-layout>

    <!-- 充值/扣款对话框 -->
    <a-modal v-model:open="editMoneyDialogData.show" title="手动充值/扣款" :width="520" centered>
        <a-tabs v-model:activeKey="editMoneyDialogData.type" @change="handleClick">
            <a-tab-pane key="1" tab="充值"></a-tab-pane>
            <a-tab-pane key="2" tab="扣款"></a-tab-pane>
        </a-tabs>
        <a-form :model="editMoneyDialogData" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }"
            style="margin-top: 16px;">
            <a-form-item label="金额">
                <a-input-number v-model:value="editMoneyDialogData.money" style="width: 100%;" :min="0"
                    :precision="2" />
            </a-form-item>
            <a-form-item label="备注">
                <a-input v-model:value="editMoneyDialogData.remark" />
            </a-form-item>
        </a-form>
        <template #footer>
            <a-button @click="editMoneyDialogData.show = false">取消</a-button>
            <a-button type="primary" @click="submitEditMoney">确认</a-button>
        </template>
    </a-modal>

    <!-- 编辑用户对话框 -->
    <a-modal v-model:open="editDialogData.show" title="编辑用户" :width="560" centered>
        <a-form :model="editDialogData.data" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }">
            <a-form-item label="用户ID">
                <a-input v-model:value="editDialogData.data.uid" disabled />
            </a-form-item>
            <a-form-item label="用户名">
                <a-input v-model:value="editDialogData.data.username" />
            </a-form-item>
            <a-form-item label="邮箱">
                <a-input v-model:value="editDialogData.data.user_email" />
            </a-form-item>
            <a-form-item label="上级ID">
                <a-input v-model:value="editDialogData.data.higher_uid" />
            </a-form-item>
            <a-form-item label="密码">
                <a-input v-model:value="editDialogData.data.password" placeholder="不修改请留空" />
            </a-form-item>
        </a-form>
        <template #footer>
            <a-button @click="editDialogData.show = false">取消</a-button>
            <a-button type="primary" @click="submitEdit">确认</a-button>
        </template>
    </a-modal>
</template>

<script>
import { defineComponent } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { message } from 'ant-design-vue'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
    components: {
        UserHead,
        HeadTop,
    },
    data() {
        return {
            tableLoading: false,
            userList: {
                total: 0,
                pageSize: 10,
                currentPage: 1,
                keyword: "",
                data: []
            },
            editDialogData: {
                show: false,
                data: {
                    uid: "",
                    username: "",
                    user_email: "",
                    higher_uid: "",
                    password: "",
                }
            },
            editMoneyDialogData: {
                type: "1",
                show: false,
                uid: "",
                money: 0.00,
                remark: ""
            }
        }
    },
    computed: {
        tableColumns() {
            return [
                { title: 'UID', dataIndex: 'uid', key: 'uid', width: 90, align: 'center' },
                { title: '邮箱', dataIndex: 'user_email', key: 'user_email', width: 200 },
                { title: '昵称', dataIndex: 'username', key: 'username', width: 140 },
                { title: '上级UID', dataIndex: 'higher_uid', key: 'higher_uid', width: 100 },
                { title: '余额', key: 'money', width: 100 },
                { title: '操作', key: 'action', width: 120, fixed: 'right' },
            ];
        }
    },
    methods: {
        onPageChange(page, pageSize) {
            this.userList.currentPage = page;
            if (pageSize !== undefined) this.userList.pageSize = pageSize;
            this.getUserList();
        },
        onSizeChange(current, size) {
            this.userList.currentPage = 1;
            this.userList.pageSize = size;
            this.getUserList();
        },
        handleClick() {
            // tab change handler
        },
        getUserList() {
            openLoading()
            this.tableLoading = true
            const data = {
                keyword: this.userList.keyword,
                pageSize: this.userList.pageSize,
                currentPage: this.userList.currentPage
            }
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.post(baseURL + '/adminApi/userManage/getAllUser', data, { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        this.userList.data = res.data.data.data
                        this.userList.total = res.data.data.total
                        return
                    } else {
                        message.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                    }
                }).catch(err => {
                    message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                    this.tableLoading = false
                })
        },
        editDialog(data) {
            this.editDialogData.data = { ...data };
            this.editDialogData.show = true;
        },
        submitEdit() {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token")
            }
            axios.post(baseURL + '/adminApi/userManage/updateUserInfo', this.editDialogData.data, { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        message.success(res.data.msg)
                        this.editDialogData.show = false;
                        this.getUserList();
                        return
                    } else {
                        message.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                    }
                }).catch(err => {
                    message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        submitEditMoney() {
            openLoading()
            const headers = {
                'token': localStorage.getItem("token")
            };
            const data = {
                type: parseInt(this.editMoneyDialogData.type),
                uid: this.editMoneyDialogData.uid,
                money: this.editMoneyDialogData.money,
                remark: this.editMoneyDialogData.remark
            }
            axios.post(baseURL + '/adminApi/userManage/updateUserMoney', data, { timeout: 30000, headers })
                .then(res => {
                    if (res.data.code == 200) {
                        message.success(res.data.msg)
                        this.editMoneyDialogData.show = false;
                        this.getUserList();
                        return
                    } else {
                        message.error(res.data.msg)
                    }
                    if (res.data.code == 401) {
                        setTimeout(() => {
                            location.href = "/Login"
                        }, 1000);
                    }
                }).catch(err => {
                    message.error(err)
                }).finally(() => {
                    fullscreenLoading.close()
                })
        },
        editMoneyDialog(data) {
            this.editMoneyDialogData.uid = data.uid;
            this.editMoneyDialogData.show = true;
        },
    },
    mounted() {
        this.getUserList()
    }
})
</script>
